import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ArticleHeroBlock/ArticleHeroBlock.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(nlx)/news/[segments]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Tag/Tag.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/LongformTextBlock/LongformTextBlock.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ImageBlock/ImageBlock.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Prose/Prose.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/FeaturedStoriesCard/FeaturedStoriesCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/RelatedArticlesBlock/RelatedArticlesBlock.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VideoBlock/VideoBlock.tsx");
